import { klarnaElements } from '@klarna-web-sdk/utils/src/constants'

export const buildPlacementSelectorName = (clientInstanceName?: string) => {
  return clientInstanceName && clientInstanceName !== 'default'
    ? klarnaElements.PLACEMENT + '-' + clientInstanceName
    : klarnaElements.PLACEMENT
}
